import InsufficientIcon from '../../../images/token-insufficient-icon.png';
import RevokedIcon from '../../../images/token-revoked-icon.png';
import TeamsLimitedIcon from '../../../images/token-teams-limited-icon.png';

import * as Styled from './TokenStatusStyles';

const tokensMapping:any = {
  insufficient: {
    icon: InsufficientIcon,
    text: 'We need a little more help! Please connect again to your account and make sure to check the box "View your email messages and settings". This way, Trova can index your content to search.'
  },
  revoked: {
    icon: RevokedIcon,
    text: 'Trova needs your help. Please connect again.'
  },
  'o365-insufficient': {
    icon: TeamsLimitedIcon,
    text: (
      <span>
        Your O365 account is limited. Please contact your IT department to resolve the scope issue and then connect again to Trova. If you have more questions, please don't hesitate to contact us at <a href="mailto:info@gotrova.ai">info@gotrova.ai</a>.
      </span>
    )
  },
  "teams-limited": {
    icon: TeamsLimitedIcon,
    text: (
      <span>
        Your Teams account is limited and requires authorization from your Office 365 admin before set up. Please ask your Office 365 admin to contact the Trova team at <a href="mailto:info@gotrova.ai">info@gotrova.ai</a>.
      </span>
    ),
  },
  "missing_permission": {
    icon: TeamsLimitedIcon,
    text: (
      <span>
        Your Teams account is limited and requires authorization from your Office 365 admin before set up. Please ask your Office 365 admin to contact the Trova team at <a href="mailto:info@gotrova.ai">info@gotrova.ai</a>.
      </span>
    ),
  }
}

interface TokenStatusProps{
  status?: string,
  item: any,
}

const TokenStatus = ({ status, item }:TokenStatusProps) => {
  if (!status || status === 'valid') {
    return null;
  }
  let tokenData = tokensMapping[status]
  if (item.o365 && status === 'insufficient') {
    tokenData = tokensMapping['o365-insufficient']
  }

  return (
    <Styled.StatusContainer>
      <Styled.TokenIcon src={tokenData.icon} />
      <Styled.Explanation className="exp">
        {tokenData.text}
      </Styled.Explanation>
    </Styled.StatusContainer>
  )
}

export default TokenStatus;